<template>
  <div>
    <!-- Button trigger modal -->
    <button id="login_btn" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#login" style="display:none;">
    </button>
    <button id="register_btn" class="btn btn-primary" data-bs-toggle="modal" href="#registerModalToggle"
      style="display:none;"></button>
    <login v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
    <changePassword v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
    <historialIngresos v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
    <register ref="register" v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
    <supportJmModal ref="supportModalMobile" modal-id="supportJmMobile" />
    <nav v-if="user.token !== ''" class="navbarCustom navbar-dark py-0" id="mainHeader">
      <myAccountJM v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
      <div class="d-flex p-2 py-2" style="width:100%;max-height: 50px;" :style="skin.header_mobil.nav_bar">
        <span style="width: 10%;" class="position-relative me-2 my-1" data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasExample" aria-controls="offcanvasExample">
          <span style="font-size: large;"><i class="fas fa-bars"></i></span>
        </span>

        <div style="width: 90%;" class="d-flex" :style="skin.header_desktop.nav_bar_text">

          <div v-if="user.token != ''" class="px-2 pe-2 d-flex align-items-center justify-content-end"
            style="flex:1;gap:16px;" :style="skin.header_desktop.selection">

            <div v-if="skin.customActionButton.enabled" @click="user.token != '' ? action() : login()"
              class="btn-support" href="#" aria-expanded="false"
              sstyle="cursor:pointer;width:5%;display:table-cell;vertical-align:middle;font-size: 15px;">
              <i class="fa fa-external-link fa-fw"></i>
            </div>
            <div v-if="skin.header_mobil.balance" style="cursor:pointer;font-size: 15px;"
              class="d-flex align-items-center">
              <i @click="showBalanceAction" class="fas fa-sync-alt pr-0 icon-balance"
                :class="{ 'icon-balance-refreshing': isBalanceRefreshing }"></i>
              <span class="mx-2">{{ user.user_data.data ? new
                Intl.NumberFormat("de-DE", {
                  minimumFractionDigits:
                    skin.qBet_config.decimalsQty, maximumFractionDigits:
                    skin.qBet_config.decimalsQty
                }).format(balance.saldo) : 0 }}</span>
            </div>
            <div v-if="skin.my_account.myaccount_type == 'JM' && skin.header_mobil.support" ref="supportWrapperMobile"
              class="position-relative" style="cursor:pointer;">
              <span :style="(this.message_recived ? 'color:red;' : '')" @click.stop="openSupportModalJivo()">
                <i class="far fa-comment-dots"></i>
              </span>
              <div v-if="showSupportPanel" class="support-dropdown">
                <div class="support-dropdown-title">
                  &bull; {{ translate('mesa') }} &bull;
                </div>
                <button type="button" class="support-dropdown-row support-report-option"
                  @click.stop="openSupportModal('newMessage')">
                  <span class="support-dropdown-icon">
                    <i class="fa fa-paper-plane"></i>
                  </span>
                  <span class="support-dropdown-text">{{ translate('reportar') }}</span>
                </button>
                <a class="support-dropdown-row support-dropdown-ticket" v-for="(ticket, index) in supportTickets"
                  :key="'new-' + index" href="#" @click.prevent.stop="openSupportModal(ticket)">
                  <span class="support-dropdown-icon">
                    <i class="fa-regular fa-comment"></i>
                  </span>
                  <span class="support-dropdown-text">Ticket #{{ ticket.id }}</span>
                  <span class="support-dropdown-meta">
                    {{ countDays(ticket.fecha) }}d
                    <i class="far fa-clock" aria-hidden="true"></i>
                  </span>
                </a>
                <div class="support-dropdown-title support-dropdown-title-bottom">
                  &bull; {{ translate('notifi') }} &bull;
                </div>
                <template v-if="false">
                  <div class="text-center">
                    <span>• {{ translate('mesa') }} •</span>
                  </div>
                  <div class="my-1 mb-1 support-report-row" @click.stop="openSupportModal('newMessage')">
                    <i class="fa fa-paper-plane mx-2"></i>
                    <span>{{ translate('reportar') }}</span>
                  </div>
                  <div class="my-1 mb-1">
                    <a class="dropdown-item support-item support-item-read" v-for="(ticket, index) in supportTickets"
                      :key="index" href="#" @click.prevent.stop="openSupportModal(ticket)">
                      <span>Ticket #{{ ticket.id }}</span>
                      <span class="float-end"> {{ countDays(ticket.fecha) }}d <i class="far fa-clock"
                          aria-hidden="true"></i></span>
                    </a>
                  </div>
                  <div class="text-center">
                    <span>• {{ translate('notifi') }} •</span>
                  </div>
                </template>
              </div>
            </div>
          </div>

          <div v-if="user.token == '' && skin.register" @click="register"
            style="cursor:pointer;display:table;width: 100%;" :style="skin.header_desktop.register_btn"
            class="py-2 px-2 pe-2 text-center">
            <span style="display:table-cell;vertical-align:middle;">{{ translate("sign_in") }}</span>
          </div>
          <div v-if="user.token != ''" style="cursor:pointer;"
            class="py-0 my-0 pb-1 d-flex align-items-center nav-item dropdown dropstart">
            <a :style="skin.header_desktop.nav_bar_text" class="nav-link py-1" href="#" id="navbarDropdown"
              role="button" data-bs-toggle="dropdown" data-bs-offset="0,10" aria-expanded="false">
              <i class="far fa-user"></i>
            </a>
            <div style="color: #fff!important;background-color: rgba(60,60,60,.9);font-size: 15px;"
              class="dropdown-menu" aria-labelledby="navbarDropdown">
              <div class="px-2 pe-2 py-2"
                style="font-weight:600;border-bottom:1px solid rgba(255,255,255,0.15);letter-spacing:0.3px;">
                {{ user.user_data.data ? user.user_data.data.user_name : '' }}
              </div>
              <div v-if="skin.my_account.myaccount_type == 'JM' && skin.header_mobil.userMenu.changePassword"
                id="changePasswordBtn" class="px-2 pe-2 pt-2" data-bs-toggle="modal" data-bs-target="#changePasswordJm">
                <span>{{ translate('change_password') }}</span>
              </div>
              <div class="px-2 pe-2 p-1" data-bs-toggle="modal" data-bs-target="#languageModal">
                <span>Cambiar Idioma</span>
              </div>
              <div v-if="skin.my_account.myaccount_type == 'JM'">
                <div v-if="skin.header_mobil.userMenu.balanceHistory" @click="getMovements()" class="px-2 pe-2 p-1"
                  data-bs-toggle="modal" data-bs-target="#myAccountJm">
                  <span>{{ translate('balance_history') }}</span>
                </div>
              </div>
              <div v-else class="px-2 pe-2 p-1" data-bs-toggle="modal" data-bs-target="#myAccount">
                <span>{{ translate('balance_history') }}</span>
              </div>
              <div v-if="skin.my_account.myaccount_type == 'JM' && skin.header_mobil.userMenu.loginHistory"
                @click="getIngresos()" class="px-2 pe-2 p-1" data-bs-toggle="modal"
                data-bs-target="#historial_ingresos"> <span>{{
                  translate('history_ingre') }}</span> </div>
              <div class="px-2 pe-2 p-1" data-bs-toggle="modal" data-bs-target="#limitModalJm">
                <span>Limites de apuestas</span>
              </div>
              <div class="px-2 pe-2 p-1" @click="openContactAgentInfo">
                <span>Contactar a mi Agente</span>
              </div>
              <div v-if="skin.logout && !this.autologin" @click="logout" class="px-2 pe-2 p-1"> <span>{{
                  translate('close')
                  }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
    <nav v-else class="navbarCustom navbar-dark py-0" id="mainHeader">
      <div class="d-flex p-3 py-2" :style="skin.header_mobil.nav_bar" style="width: 100%;min-height: 50px;">

        <span class="align-self-center" data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample"
          aria-controls="offcanvasExample">
          <span style="color:#ccc;font-size: large;"><i class="fas fa-bars"></i></span>
        </span>
        <!-- <div><img class="mx-2" :src="skin.header_mobil.logo" :width="skin.header_mobil.logo_width" alt=""></div> -->
        <div class="text-end" style="width: 50%;">
          <button v-if="user.token == '' && skin.register" style="font-size: small;"
            class="p-1 px-2 pe-2 me-1 text-center btn" @click="register" :style="skin.header_mobil.register_btn">{{
              translate("sign_in") }}</button>
        </div>
        <div style="cursor:pointer;display:table;width: 50%;font-size: small;" :style="skin.header_desktop.login_btn"
          class="py-2 px-2 pe-2 text-end">
          <span v-if="user.token == ''" @click="login" style="display:table-cell;vertical-align:middle;"><i
              class="fas fa-sign-in-alt"></i> {{ translate("log_in") }}</span>
        </div>
        <div class="align-self-center">
          <languageSelector :skin="skin" :language="language">
          </languageSelector>
        </div>
      </div>
    </nav>
    <languageJm v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
    <betLimitsModal />
  </div>
</template>

<script>
import myAccountJM from "./my_account.vue";
import languageSelector from './language.vue';
import languageJm from './languageJm.vue';
import supportJmModal from './supportJmModal.vue';
import login from "./login.vue";
import register from './register.vue';
import changePassword from "./changePassword.vue";
import historialIngresos from "./historialIngresos.vue";
import betLimitsModal from "./betLimits.vue";
export default {
  name: "header_mobil",
  props: ["skin", "translation", "language"],
  components: { languageSelector, languageJm, supportJmModal, betLimitsModal, myAccountJM, login, register, changePassword, historialIngresos },
  data() {
    return {
      userDataLoaded: false,
      showBalance: false,
      isBalanceRefreshing: false,
      showSupportPanel: false,
      supportTickets: [],
      balance: {
        saldo: 0,
        conversion: 0,
        view: "SALDO",
        switch: 1
      },
    }
  },
  computed: {
    autologin() {
      return this.$store.getters["getAutologin"]
    },
    jivo_modal_flag() {
      return this.$store.getters["getModalFlag"]
    },
    message_recived() {
      return this.$store.getters["getMessage"]
    },
    jivoElement1() {
      return this.$store.getters['jivoElement1'];
    },
    user() {
      let data = this.$store.getters['getUserData'];
      if (data.user_data.data) {
        this.balance.saldo = data.user_data.data.balance;
        this.balance.conversion = data.user_data.data.balance * data.user_data.data.tasa;
        this.userDataLoaded = true;
      }
      return data;
    },
    currency() {
      return this.$store.getters['getCurrency'];
    },
  },
  methods: {
    action() {
      let customButton = this.$props.skin.customActionButton;
      if (customButton.action == 'redirection') {
        let url = customButton.actionData.url;
        let parameters = customButton.actionData.parameters;
        parameters.forEach(param => {
          url += `${url.includes('?') ? '&' : '?'}${param}=${encodeURIComponent(this.user.user_data.data[param])}`;
        });
        console.log(url, this.user.user_data.data, this.$props.skin.customActionButton);
        window.open(url, '_blank');
      }
    },
    openSupportModalJivo() {
      this.showSupportPanel = !this.showSupportPanel;
      if (this.showSupportPanel) {
        this.getSupportTickets();
        this.$store.dispatch("setMessage", false);
      }
    },
    openSupportModal(payload) {
      this.showSupportPanel = false;
      this.$refs.supportModalMobile?.open(payload);
    },
    async getSupportTickets() {
      this.supportTickets = [];
    },
    handleDocumentClick(event) {
      const wrapper = this.$refs.supportWrapperMobile;
      if (!wrapper) return;
      if (!wrapper.contains(event.target)) {
        this.showSupportPanel = false;
      }
    },
    showBalanceAction() {
      this.isBalanceRefreshing = false;
      this.$nextTick(() => {
        this.isBalanceRefreshing = true;
        setTimeout(() => {
          this.isBalanceRefreshing = false;
        }, 650);
      });

      if (!this.showBalance) {
        this.$store.dispatch('getProfile', {
          token: this.user.token,
          site_id: this.user.site_id,
          site: this.user.site,
          prefix: this.user.prefix,
          playerId: this.user.user_data?.data?.user_id,
          source: "main"
        });
        this.showBalance = true
      }
      else {
        this.showBalance = false
      }
    },
    countDays(init) {
      // Crear dos objetos Date con las fechas que quieres comparar
      var fecha1 = new Date(init);
      var fecha2 = new Date();

      // Calcular la diferencia en milisegundos entre las dos fechas
      var diferenciaEnMilisegundos = fecha2 - fecha1;

      // Convertir la diferencia en días
      var diferenciaEnDias = diferenciaEnMilisegundos / (1000 * 60 * 60 * 24);

      // Redondear la diferencia si es necesario
      diferenciaEnDias = Math.round(diferenciaEnDias);
      return diferenciaEnDias;
    },
    getMovements() {
      this.$root.$emit('getMovementsHistory');
    },
    getIngresos() {
      this.$root.$emit('getIngresosHistory');
    },
    show_user_recharge() {
      this.$root.$emit("show_user_recharge");
    },
    openContactAgent() {
      this.$root.$emit('openContactAgent');
    },
    openContactAgentInfo() {
      this.$root.$emit('openContactAgentInfo');
    },
    balanceParsed(val, fiat) {
      let tasa = 1;
      if (this.$props.skin.conversion ? (this.$props.skin.conversion.enabled ? true : false) : false) {
        tasa = this.currency.rate;
      }
      return (fiat != 'BETC' ? (fiat == 'USDT' ? val * tasa : val * tasa * this.user.user_data.data.tasa) : val).toFixed(2);
    },
    login() {
      document.getElementById('login_btn').click();
    },
    logout() {
      this.$store.dispatch('logOut');
      this.$root.$emit('forceRender');
    },
    register() {
      document.getElementById('register_btn').click();
    },
    change_view(view) {
      this.$store.dispatch('setView', view);
    },
    translate(text) {
      if (text) {
        if (this.$props.translation[text]) {
          return this.$props.translation[text][this.$props.language];
        }
        else {
          var new_text_serched = text.replace(/ /g, "_");
          if (this.$props.translation[new_text_serched]) {
            return this.$props.translation[new_text_serched][this.$props.language];
          }
        }
        return text;
      }
    }
  },
  watch: {
    userDataLoaded(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.getSupportTickets();
      }
    },
    showBalance(newVal, oldVal) {
      if (newVal) {
        let self = this
        setTimeout(() => {
          self.showBalance = false
        }, 5000);
      }
    }
  },
  mounted() {
    this.$store.dispatch("setHeaderHeight", document.getElementById("mainHeader").offsetHeight + 5);
    document.addEventListener('click', this.handleDocumentClick);
    this.$root.$on('openLogin', () => {
      this.login();
    });
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleDocumentClick);
    this.$root.$off('openLogin');
  }
}
</script>

<style scoped>
.navbarCustom {
  border: none;
  background-color: #1c1c1c;
  /* Color de fondo por defecto */
  /* position: fixed; */
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.support-dropdown-mobile {
  position: absolute;
  top: 28px;
  right: -42px;
  width: 320px;
  color: #fff;
  background-color: rgba(60, 60, 60, 0.94);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 6px;
  z-index: 1050;
  font-size: 15px;
}

.support-report-row {
  background: rgba(31, 45, 79, 0.95);
  border-radius: 4px;
  padding: 10px;
  cursor: pointer;
}

.modal-header2 {
  margin-left: 5% !important;
  margin-right: 5% !important;
  margin-top: -1.25rem !important;
  margin-bottom: 0 !important;
  height: 60px;
  padding: 1rem !important;
  color: #fff;
  border-bottom: none;
  background: linear-gradient(40deg, #292d3d, #03040d) !important;
}

.support-message-wrapper {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.support-file-btn {
  width: 54px;
  height: 54px;
  border-radius: 50%;
  border: 0;
  color: #fff;
  background: #1f2742;
  flex: 0 0 auto;
  margin-top: 8px;
}

.support-input,
.support-textarea {
  width: 100%;
  border: 0;
  border-radius: 10px;
  padding: 14px 16px;
  font-size: 16px;
  color: #222;
}

.support-textarea {
  min-height: 220px;
  resize: vertical;
}

.support-actions {
  display: flex;
  gap: 10px;
  justify-content: center;
}

.support-btn {
  border: 0;
  border-radius: 6px;
  padding: 12px 22px;
  color: #fff;
  background: #1f2742;
}

.icon-balance {
  color: lightgreen !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1em;
  height: 1em;
  line-height: 1;
  transition: transform 0.2s ease, color 0.2s ease;
  transform-origin: 50% 50%;
  will-change: transform;
}

.icon-balance-refreshing {
  animation: balance-refresh-spin 0.36s linear;
}

@keyframes balance-refresh-spin {
  0% {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

span {
  font-family: "Metropolis";
  font-size: 15px;
  font-weight: 500;
  color: #fff;
}

.support-dropdown {
  position: absolute;
  top: 38px;
  left: auto;
  right: -58px;
  transform: none;
  width: 15rem;
  color: #000;
  /* background-color: rgba(60, 60, 60, 0.94); */
  background-color: rgba(60, 60, 60, .9);
  border: #000;
  border-radius: 6px;
  z-index: 1050;
  font-size: 15px;
  margin-top: 3px;
  padding: 8px;
  font-size: .8rem;
  font-weight: 300;
  font-family: "Metropolis"
}

.support-dropdown-title {
  font-family: "Metropolis";
  margin-top: 10px;
  margin-bottom: 10px;
  color: #fff;
  font-size: .8rem;
  font-weight: 500;
  text-align: left;
}

.support-dropdown-row {
  font-family: "Metropolis";
  font-size: 15px;
  background: transparent;
  border: none;
  color: #fff;
  display: flex;
  justify-content: left;
  margin: 14px;
}

.support-report-option {
  margin: 0;
}

.support-dropdown-row:hover {
  background-color: #292d3d;
}

.support-dropdown-icon {
  margin-right: 10px;
  width: 20px;
}

.support-dropdown-text {
  font-size: .8rem;
  font-weight: 500;
}

.nav-item.dropdown.dropstart {
  position: static;
}

.nav-item.dropdown.dropstart .dropdown-menu {
  position: fixed !important;
  inset: 48px 2px auto auto !important;
  width: 220px;
  color: #fff;
  background-color: rgba(60, 60, 60, 0.94);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 6px;
  z-index: 1050;
  font-size: 15px;
  transform: none !important;
  margin: 0 !important;
}
</style>
